// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3188":"cbcfb120","4078":"c481ccaa","6531":"962a4b85"}[chunkId] + ".chunk.css";
};